import { Box } from "@mui/material";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton, FacebookIcon, LinkedinIcon, TwitterIcon } from "react-share";

const ShareButtons = (props) => {
    const shareUrl = window.location.href;
    const buttonSize = 32;
    const fillColor = '#246898';
    return (
        <Box display="flex" alignItems="center" className='shareButtonsWrapper'>
            <p style={{ padding: '5px .5rem', margin: 0, marginBottom: '6px' }}>Share on: </p>
            <TwitterShareButton url={shareUrl} children={<TwitterIcon bgStyle={{ fill: fillColor }} size={buttonSize} round={true} />} />
            <FacebookShareButton url={shareUrl} children={<FacebookIcon bgStyle={{ fill: fillColor }} size={buttonSize} round={true} />} />
            <LinkedinShareButton url={shareUrl} children={<LinkedinIcon bgStyle={{ fill: fillColor }} size={buttonSize} round={true} />} />
        </Box >
    );

}

export default ShareButtons;